import { ADModalBody, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { ManagedWindow } from "src/WindowManager/WindowState";
import { GlassInputControl } from "./GlassInput";
import { actionUpdateMapInfo, MapitStateContext } from "src/states/MapitState";
import { useContext } from "react";
import { Localization } from "@viamap/viamap2-common";
import { ApplicationStateContext, Feature } from "src/states/ApplicationState";


export function MapDescription(props: { window: ManagedWindow, onClose: () => void }) {
   const { state: mapitState, dispatch: mapitDispatch } = useContext(MapitStateContext)
   const { hasAccessToFeature } = useContext(ApplicationStateContext);

   return (
      <AdvancedDragModal variant={"Small"} window={props.window} onClose={props.onClose}
         PosDefault={{ left: "97%", top: "40px", width: "300px", height: "400px", transform: "translate(-97%, 0)" }}
         title={Localization.getText("Map Description")}>
         <ADModalBody>
            <div style={{ padding: "2px", display: "flex", flex: "auto", flexDirection: "column" }} >
               <GlassInputControl>
                  <textarea readOnly={!hasAccessToFeature(Feature.EditMapDescription)} value={mapitState.mapInfo.mapDescription || ""} style={{ width: "100%", height: "100%", resize: "none" }}
                     onChange={(e) => mapitDispatch(actionUpdateMapInfo({ mapDescription: e.target.value }))}
                  ></textarea>
               </GlassInputControl>
               <MapInfoMetaData />
            </div>
         </ADModalBody>
      </AdvancedDragModal>
   )

}

function MapInfoMetaData() {
   const { state: mapitState } = useContext(MapitStateContext);

   return (
      <div style={{ marginTop: "10px", marginLeft: "1ex", fontSize: "12px" }}>
         {mapitState.mapInfo.mapTitle ? <div style={{ fontWeight: "bold" }}>{mapitState.mapInfo.mapTitle}</div> : null}
         {mapitState.mapInfo.lastPublished ? <div>{Localization.getFormattedText("Last Published: {date}", { date: new Date(mapitState.mapInfo.lastPublished).toLocaleString() })}</div> : null}
         {mapitState.mapInfo.lastPublisher ? <div>{Localization.getFormattedText("Published by: {mail}", { mail: mapitState.mapInfo.lastPublisher })}</div> : null}
      </div>
   )

}